import i18n from 'i18next'
import getFormattedDate, { dateFormats } from './dateFormatHelper'

export default function generateCitationData({
  creator,
  createdDate,
  custodian,
  place,
  location,
  imageIndex,
  imageCount,
}) {
  const listFormat = new Intl.ListFormat(i18n.language, { style: 'narrow', type: 'conjunction' })

  const ark = location?.pathname?.split('/').pop()
  let coverageString = ''
  let custodianString = ''
  const createdDateFormatted = getFormattedDate(createdDate?.fromTimestamp, null, dateFormats.formatted)
  const currentDateFormatted = getFormattedDate(Date.now(), null, dateFormats.formatted)

  if (place) {
    coverageString = `"${place} ${i18n.t('generateCitation.records', 'records')},${
      createdDateFormatted ? ` ${createdDateFormatted},` : ''
    }"`
  } else if (createdDateFormatted) {
    coverageString = `"${createdDateFormatted},"`
  }

  if (custodian) {
    custodianString = custodian
  } else if (Array.isArray(creator) && creator?.length > 0) {
    custodianString = listFormat.format(creator)
  }

  const imageCitation = i18n.t('generateCitation.image-number', 'image {number} of {totalNumber}', {
    number: imageIndex + 1,
    totalNumber: imageCount,
  })

  return {
    coverageString,
    currentDateFormatted,
    imageCitation,
    custodianString,
    ark,
  }
}
